import { PageTemplate, HeaderTemplate, ButtonLink, Button } from "../styles";
import { useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { useState, useEffect, useContext } from "react";
import { updateStatus, createReturn } from "../api/order";
import { useNavigate } from "react-router-dom";
import { getProductStock } from "../api/misc";
import { Modal } from "react-bootstrap";
import { DataContext } from "../DataContext";
import { renderSizeOptions, renderSizeAbbreviationHTML } from "../utils";
import { useAuth0 } from "@auth0/auth0-react";
import { ReturnReviewTemplate } from "../templates/ReturnReviewTemplate";
import toast from "react-hot-toast";
import styled from "styled-components";
import { ASSET_URL } from "../constants";

const ReviewButton = styled(Button)`
  width: fit-content;
  margin: 0 auto;
  padding: 8px 40px;
`;

const OrderNumber = styled.p`
  background-color: var(--dark-grey-highlight);
  color: var(--white);
  border-radius: 5px;
  padding: 20px 30px;
  margin-bottom: 20px;
  span {
    font-weight: 700;
  }
  @media only screen and (max-width: 991px) {
    padding: 20px;
  }
`;

const Return = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { getCustomer } = useContext(DataContext);
  const { isAuthenticated } = useAuth0();

  const currentOrder = state?.order;

  const productId = "prod_OdiHceEPLy8W3Z";
  const [products, setProducts] = useState([]);
  const [productStock, setProductStock] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [shippingRate, setShippingRate] = useState(null);
  const [productsWithErrors, setProductsWithErrors] = useState([]);
  const [formSubmittedWithDropdownErrors, setFormSubmittedWithDropdownErrors] = useState(false);

  // component mount
  useEffect(() => {
    const fetchData = async () => {
      if (currentOrder) {
        if (currentOrder.returns.length > 0) {
          setProducts(filterReturnedProducts(currentOrder.returns[currentOrder.returns.length - 1].products));
        } else {
          setProducts(flattenProducts(currentOrder.products));
        }
        setShippingRate(currentOrder.shippingRate);
        getProductStockFunc();
      }
    };
    fetchData();
  }, []);

  // products update
  useEffect(() => {
    if (formSubmittedWithDropdownErrors) {
      createItemErrorList();
    }
  }, [products]);

  const filterReturnedProducts = (products) => {
    const filteredProducts = products.filter((product) => {
      return product.returnType === "Keep";
    });
    return filteredProducts;
  };

  const flattenProducts = (productsArray) => {
    const flattenedProducts = [];
    productsArray.forEach((product) => {
      for (let i = 0; i < product.quantity; i++) {
        flattenedProducts.push({
          returnType: "Keep",
          returnReason: "",
          sizeExchange: null,
          positionExchange: null,
          selected: false,
          design: product.design,
          itemId: Math.floor(Math.random() * 1000000000),
          position: product.position,
          productCost: product.productCost,
          size: product.size,
          productId: product.productId,
        });
      }
    });
    return flattenedProducts;
  };

  const getProductStockFunc = async () => {
    try {
      const stock = await getProductStock(productId);
      setProductStock(stock);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  // this creates a list of products with errors to display an error background color
  const createItemErrorList = () => {
    const errors = [];
    products.forEach(({ returnType, returnReason, sizeExchange, positionExchange, itemId, selected }) => {
      if (
        (selected && returnType === "Keep") ||
        (selected && (returnReason === "" || returnReason === null)) ||
        (returnType === "Exchange" &&
          (sizeExchange === null || sizeExchange === "" || positionExchange === null || positionExchange === ""))
      ) {
        errors.push(itemId);
      }
    });
    setProductsWithErrors(errors);
  };

  const handleReviewReturn = () => {
    let errorMessage = null;

    const selectedProducts = products.filter((product) => {
      return product.selected === true;
    });

    createItemErrorList();

    const allReturnTypesSelected = selectedProducts.every((product) => {
      return product.returnType !== "Keep" && product.returnReason !== "" && product.returnReason !== null;
    });

    const exchangeDropdownsSelected = selectedProducts.every(({ returnType, sizeExchange, positionExchange }) => {
      if (returnType === "Exchange") {
        return sizeExchange !== null && sizeExchange !== "" && positionExchange !== null && positionExchange !== "";
      } else {
        return true;
      }
    });

    if (selectedProducts.length === 0) {
      // make sure at least one product has been selected
      errorMessage = "Choose at least one product";
    } else if (selectedProducts.length > 0 && !allReturnTypesSelected) {
      // make sure all selected products have returnType Refund or Exchange
      // and all have a return reason
      errorMessage = "Choose a return type and reason for all selected products";
      setFormSubmittedWithDropdownErrors(true);
    } else if (selectedProducts.length > 0 && !exchangeDropdownsSelected) {
      // if product returnType is Exchange, make sure sizeExchange && positionExchange have values
      errorMessage = "Choose a new size and position for all selected products to be exchanged.";
      setFormSubmittedWithDropdownErrors(true);
    }

    if (!errorMessage) {
      setShowReviewModal(true);
    } else {
      toast.error(errorMessage);
    }
  };

  const handleReturnSubmission = async () => {
    try {
      const returnObj = {
        order: currentOrder,
        products,
        orderProductCount: flattenProducts(currentOrder.products).length,
      };
      await createReturn(returnObj);
      await updateStatus({
        orderNumber: currentOrder.orderNumber,
        status: "return",
      });
      // only get customer if logged in
      if (isAuthenticated) {
        getCustomer();
      }
      navigate("/return/confirmation", {
        state: {
          orderNumber: currentOrder.orderNumber,
          orderEmail: currentOrder.billing.email,
        },
      });
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  const renderProducts = () => {
    return products?.map((product) => {
      const hasError = !!productsWithErrors.find((item) => {
        return item === product.itemId;
      });
      return (
        <div className="start-return-exchange-row" key={product._id}>
          <div className="return-exchange-product">
            <div>
              <Form.Check
                onChange={(e) => handleProductSelect(product.itemId, e.target.checked)}
                type={"checkbox"}
                id={"separate-billing"}
                label={""}
                checked={product.selected}
              />
            </div>
            <div className="product-image border">
              <picture>
                <source srcset={`${ASSET_URL}/designs/small/${product.design}-logo.avif`} type="image/avif" />
                <img src={`${ASSET_URL}/designs/${product.design}-logo.gif`} />
              </picture>
            </div>
            <div className="return-exchange-details">
              <div>
                <span>Size</span>
                <strong className="size-badge" dangerouslySetInnerHTML={{ __html: renderSizeAbbreviationHTML(product.size) }} />
              </div>
              <div>
                <span>Position</span>
                <strong>{product.position}</strong>
              </div>
            </div>
          </div>
          <div className={`return-exchange-dropdowns ${!product.selected && "hide"} ${hasError && "error"}`}>
            <div className="left-return-options">
              <div className="return-type">
                <Form.Select
                  name="returnType"
                  id="returnType"
                  value={product.returnType}
                  onChange={(e) => handleSelection(product.itemId, "returnType", e.target.value)}
                >
                  <option value="Keep">Select Return Type</option>
                  {currentOrder.returns.length === 0 && <option value="Exchange">Exchange</option>}
                  <option value="Refund">Refund</option>
                </Form.Select>
              </div>
              <div className="return-reason">
                <Form.Select
                  name="returnReason"
                  id="returnReason"
                  value={product.returnReason}
                  onChange={(e) => handleSelection(product.itemId, "returnReason", e.target.value)}
                >
                  <option value="">Select Return Reason</option>
                  <option value="too-short">Too Short</option>
                  <option value="too-long">Too Long</option>
                  <option value="too-tight">Too Tight</option>
                  <option value="too-loose">Too Loose</option>
                </Form.Select>
              </div>
            </div>

            <div className="right-return-options">
              {product.returnType === "Exchange" && (
                <div className="exchange-dropdowns">
                  <Form.Select
                    name="sizeExchange"
                    id="sizeExchange"
                    value={product.sizeExchange}
                    onChange={(e) => handleSelection(product.itemId, "sizeExchange", e.target.value)}
                  >
                    <option value="">Exchange Size</option>
                    {renderSizeOptions(productStock, product.size)}
                  </Form.Select>
                  <Form.Select
                    name="positionExchange"
                    id="positionExchange"
                    value={product.positionExchange}
                    onChange={(e) => handleSelection(product.itemId, "positionExchange", e.target.value)}
                  >
                    <option value="">Exchange Position</option>
                    <option value="">-----</option>
                    <option value="Front">Front</option>
                    <option value="Back">Back</option>
                  </Form.Select>
                </div>
              )}
              {product.returnType === "Refund" && (
                <div className="refund-amount">
                  Refund Amount<span>${product.productCost}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  // removes error from updated product
  const updateFormErrors = (itemId) => {
    setFormSubmittedWithDropdownErrors(false);
    const updatedProducts = productsWithErrors.filter((item) => {
      return item !== itemId;
    });
    setProductsWithErrors(updatedProducts);
  };

  const handleProductSelect = (itemId, value) => {
    updateFormErrors(itemId);
    const item = products.find((product) => {
      return product.itemId === itemId;
    });
    let updatedItem = { ...item, selected: value };

    const updatedProductArray = products.map((product) => {
      if (itemId === product.itemId) {
        if (value === true) {
          return updatedItem;
        } else {
          return {
            ...updatedItem,
            sizeExchange: null,
            positionExchange: null,
            returnType: "Keep",
          };
        }
      } else {
        return product;
      }
    });
    setProducts(updatedProductArray);
  };

  const handleSelection = (itemId, field, value) => {
    updateFormErrors(itemId);
    const item = products.find((product) => {
      return product.itemId === itemId;
    });
    let updatedItem = { ...item, [field]: value };
    if (updatedItem.returnType === "Keep" || updatedItem.returnType === "Refund") {
      updatedItem = {
        ...updatedItem,
        sizeExchange: null,
        positionExchange: null,
      };
    }
    const updatedProductArray = products.map((product) => {
      if (itemId === product.itemId) {
        return updatedItem;
      } else {
        return product;
      }
    });
    setProducts(updatedProductArray);
  };

  if (!state) return null;

  return (
    <>
      <HeaderTemplate className="narrow">
        <div className="header flex-header">
          <div className="title">
            <h1>Start a Return</h1>
          </div>
          {isAuthenticated && (
            <div className="breadcrumb">
              <ButtonLink to="/account" className="small clear">
                Back to Orders
              </ButtonLink>
            </div>
          )}
        </div>
        <OrderNumber>
          Order # <span>{currentOrder.orderNumber}</span>
        </OrderNumber>
        <h2 className="center">Select the product(s) that you would like to return.</h2>
      </HeaderTemplate>
      <PageTemplate className="narrow">
        <div className="body">
          <div className="start-exchange">{renderProducts()}</div>

          <ReviewButton onClick={handleReviewReturn}>Continue</ReviewButton>
          <p style={{ marginTop: "20px", fontStyle: "italic", padding: "0 20px", textAlign: "center" }}>
            <strong>1 Free Return Per Order</strong>
            <br />
            One free return allowed per order. Additional returns are subject to a shipping fee.
          </p>
        </div>
      </PageTemplate>
      <Modal size={"lg"} fullscreen={"md-down"} show={showReviewModal} onHide={() => setShowReviewModal(false)}>
        <ReturnReviewTemplate
          products={products}
          submit={handleReturnSubmission}
          isFirstReturn={currentOrder.returns.length === 0}
          shippingRate={shippingRate}
          salesTax={currentOrder.salesTax}
          customerPostalCode={currentOrder.shipping.address.postal_code}
          orderProductCount={flattenProducts(currentOrder.products).length}
        />
      </Modal>
    </>
  );
};

export default Return;
